import { PromotionalCode } from '@api/PromotionalCodes/PromotionalCode';
import PromotionalCodeServ from '@api/PromotionalCodes/PromotionalCodeServ';

class PromotionalCodeService {
    savePromotionalCode = (promotionalCode: PromotionalCode): Promise<PromotionalCode> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await PromotionalCodeServ.savePromotionalCode(promotionalCode);
                resolve(data);
            } catch (error) {
                reject('Error saving promotional code: ' + error);
            }
        });
    };
    getPromotionalCodes = (): Promise<PromotionalCode[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await PromotionalCodeServ.getPromotionalCodes();
                resolve(data);
            } catch (error) {
                reject('Error getting promotional codes: ' + error);
            }
        });
    };
    getPromotionalCode = (promotionalCodeId: string): Promise<PromotionalCode> => {
        return new Promise(async (resolve, reject) => {
            try {
                const promotionalCode = await PromotionalCodeServ.getPromotionalCode(promotionalCodeId);
                resolve(promotionalCode);
            } catch (error) {
                reject('Error getting promotional code: ' + error);
            }
        });
    };
    toggleStatus = (promotionalCodeId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await PromotionalCodeServ.toggleStatus(promotionalCodeId);
                resolve();
            } catch (error) {
                reject('Error updating promotional code status: ' + error);
            }
        });
    };
    verifyCode = (code: string, branchOfficeId: string): Promise<PromotionalCode> => {
        return new Promise(async (resolve, reject) => {
            try {
                const promotionalCode = await PromotionalCodeServ.verifyCode(code, branchOfficeId);
                resolve(promotionalCode);
            } catch (error) {
                reject(error);
            }
        });
    };
    deletePromotionalCode = (promotionalCodeId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await PromotionalCodeServ.deletePromotionalCode(promotionalCodeId);
                resolve();
            } catch (error) {
                reject('Error deleting promotional code: ' + error);
            }
        });
    };
}
export default PromotionalCodeService;
